"use client";

import React from "react";
import { getCurrentUser } from "../actions";

export function useAuth() {
  const [user, setUser] = React.useState(null);

  const getUser = React.useCallback(async () => {
    try {
      const response = await getCurrentUser();
      setUser(response);
    } catch (error) {
      setUser(null);
    }
  }, []);

  React.useEffect(() => {
    document.addEventListener("DOMContentLoaded", getUser);
    document.addEventListener("visibilitychange", getUser);

    return () => {
      document.removeEventListener("DOMContentLoaded", getUser);
      document.removeEventListener("visibilitychange", getUser);
    };
  }, []);

  return { user };
}
